import React, { SVGProps } from 'react';

export const DownloadFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.173 1.5H2.7v14.1h1.8V3.3h8.4v5.1a1.5 1.5 0 0 0 1.5 1.5h5.1v5.7h1.8V8.627L14.173 1.5Zm4.054 6.6H14.7V4.573L18.227 8.1Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.07 18.9V12h1.8v6.9l3.554-3.554 1.275 1.275-5.73 5.729-5.736-5.737 1.276-1.275 3.56 3.562Z"
    />
  </svg>
);
